import { createInstance as e } from "i18next";
import { initI18nInstance as r } from "./index24.mjs";
const o = (t) => {
  const n = e();
  return r(n, t);
};
export {
  o as createI18nInstance
};
